import { api } from '@/modules/shared/lib/axios'
import type { ResponseAPI } from '@/modules/shared/types/response-api.type'

export type TClienteDeleteActionService = {
  payload: {
    clientId: string
  }
}

export const clienteDeleteActionService = async ({
  payload,
}: TClienteDeleteActionService): Promise<ResponseAPI> => {
  const { clientId } = payload

  const { data } = await api.get(`excluircliente/${clientId}`)

  return data
}
